var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ps-lg-7 pt-4"},[(_vm.coupons.length)?_c('v-row',{staticClass:"row-cols-1 row-cols-sm-2 row-cols-md-3"},_vm._l((_vm.coupons),function(coupon,i){return _c('v-col',{key:i},[_c('coupon-box',{attrs:{"is-loading":_vm.loading,"coupon-details":coupon}})],1)}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }